var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell class-course-page"},[_c('MobileTopNav',{attrs:{"title":"班课课程"}}),_c('main',{staticClass:"class-course-placeholder"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }